module.exports = __webpack_public_path__ + "static/media/pain_stimulus.c82e9b95.png";